import React from "react";

import classNames from "classnames";

import type { JSX, ReactElement } from "react";

interface MenuTitleProps {
  title: ReactElement | string;
  isCollapsed?: boolean;
  collapsedSidebarClassNames: (isCollapsed?: boolean) => string;
}

function MenuTitle({
  title,
  isCollapsed,
  collapsedSidebarClassNames,
}: MenuTitleProps): JSX.Element {
  const wrapperClassNames = classNames("w-[200px] h-[50px] flex items-center");

  const titleClassNames = classNames(
    "min-w-full cursor-default pl-[1.40625rem] uppercase text-muted-foreground truncate",
    collapsedSidebarClassNames(isCollapsed),
  );
  return (
    <div className={wrapperClassNames}>
      <div
        className={titleClassNames}
        title={typeof title === "string" ? title : undefined}
      >
        {title}
      </div>
    </div>
  );
}

export default MenuTitle;
